import ExcelJS from "exceljs";
import { useCallback } from "react";
import { Structure } from "../excel-template";
import { convertIndexToAlphaBet } from "./useExcelTemplate";

const allBorders: Partial<ExcelJS.Borders> = {
  top: { style: "thin" },
  bottom: { style: "thin" },
  left: { style: "thin" },
  right: { style: "thin" },
};

const headerFill: ExcelJS.Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: {
    argb: "B8CCE4",
  },
};

const headerAlignment: Partial<ExcelJS.Alignment> = {
  horizontal: "center",
  vertical: "top",
  wrapText: true,
};

const contentAlignment: Partial<ExcelJS.Alignment> = {
  horizontal: "left",
  vertical: "top",
  wrapText: true,
};

const useExcelStyle = () => {
  const styles = useCallback(
    <T>(ws: ExcelJS.Worksheet, structures: Structure<T>[], contentNumber: number = 10) => {
      structures.forEach((s, i) => {
        const alphabet = convertIndexToAlphaBet(i); // A, B, C, D, E

        /**
         * Header Cell
         */
        const headerCell = ws.getCell(`${alphabet}1`);
        headerCell.border = allBorders;
        headerCell.font = { bold: true };
        headerCell.fill = headerFill;
        headerCell.alignment = headerAlignment;

        /**
         * Content Cell
         */
        for (let cellIndex = 2; cellIndex <= contentNumber + 2; cellIndex++) {
          const contentCell = ws.getCell(`${alphabet}${cellIndex}`);
          contentCell.border = allBorders;
          contentCell.alignment = contentAlignment;
        }
      });
    },
    []
  );

  return styles;
};

export default useExcelStyle;
